export default __webpack_public_path__ + "static/media/GOJELLY_Logo_v01.7d67bdef.svg";